<div class="loading-overlay" *ngIf="loading$ | async">
  <p-progressSpinner></p-progressSpinner>
</div>
